import { render, staticRenderFns } from "./LowBalanceAlert.vue?vue&type=template&id=173e1236"
import script from "./LowBalanceAlert.vue?vue&type=script&lang=js"
export * from "./LowBalanceAlert.vue?vue&type=script&lang=js"
import style0 from "./LowBalanceAlert.vue?vue&type=style&index=0&id=173e1236&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports